/* eslint-disable no-console */
import {Col, Form, Input, Row, Select} from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import React, {useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import {ReactComponent as YearCalender} from '../../assets/yearCalender.svg';
import {CommonErrors} from '../../constants/Common';
import {rowGutter} from '../../pages/configurator/orgFacility/Constants/Common';
import {OPplaceholder} from '../../pages/configurator/orgFacility/orgInfo/constants/orgProfileKeyLabel';
import NumberInput from '../../shared/NumberInput';
import useCompanyStore from '../../store/companyStore/companyDetailsStore';
import useJSONStore from '../../store/StaticJson/jsonStore';
import {
  AllCap,
  eachWordCapOrAllCap,
  FirstCap
} from '../../utils/FormUtils/FirstCap';
import RegEx from '../../utils/FormUtils/RegEx';
import {yearSelect} from '../../utils/FormUtils/yearSelect';
import PhoneNumberInput from '../CustomInputs/PhoneNumberInput/PhoneNumberInput';

import {yearKeyLabel} from './Constants/IP/commonKeyLabel';
import {franchiseKey, franchiseLabel} from './Constants/IP/franchiseKeyLabel';
import {filterSelectOptions} from './Utils/commonFunctions';

const FranchiseForm: React.FC<{
  data?: any;
  currentStep?: number;
}> = ({data = undefined, currentStep}) => {
  const countryOptions = useJSONStore((state) => state.country);
  const stateOptions = useJSONStore((state) => state.states);
  const cityOptions = useJSONStore((state) => state.city);
  const {area} = useCompanyStore.getState().preUnits;
  const yearFilter = yearSelect();
  const [searchParam] = useSearchParams();
  const FormInstance = useFormInstance();
  const {setFields} = FormInstance;
  const [country, setCountry] = useState(
    data?.[franchiseKey.COUNTRY] ? data?.[franchiseKey.COUNTRY] : undefined
  );

  return (
    <>
      {currentStep === 0 && (
        <>
          <Col className="gutter-row">
            <Form.Item
              name={yearKeyLabel.key}
              label={yearKeyLabel.label}
              labelCol={{span: 24}}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(yearKeyLabel.label)
                }
              ]}
              initialValue={searchParam.get('selectedYear')}
            >
              <Select
                placeholder={yearKeyLabel.label}
                options={yearFilter}
                suffixIcon={<YearCalender />}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <Form.Item
              name={franchiseKey.FRANCHISE_NAME}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(franchiseLabel.FRANCHISE_NAME)
                },
                {
                  max: 100,
                  message: `${franchiseLabel.FRANCHISE_NAME} should be less than 100 characters`
                },
                {
                  min: 3,
                  message: `${franchiseLabel.FRANCHISE_NAME} should be more than 2 characters`
                },
                {
                  pattern: RegEx.businessName,
                  message: CommonErrors.noAllowedSpecChar
                }
              ]}
              label={franchiseLabel.FRANCHISE_NAME}
              labelCol={{span: 24}}
            >
              <Input
                className="input"
                placeholder={`Enter ${franchiseLabel.FRANCHISE_NAME}`}
                onInput={(e) => {
                  const target = e.target as HTMLInputElement;
                  target.value = eachWordCapOrAllCap(target.value);
                }}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <Form.Item
              name={franchiseKey.FIRST_NAME}
              label={franchiseLabel.FIRST_NAME}
              labelCol={{span: 24}}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(franchiseLabel.FIRST_NAME)
                },
                {
                  max: 100,
                  message: `${franchiseLabel.FIRST_NAME} Should not be more than 100 Characters`
                },
                {
                  min: 2,
                  message: `${franchiseLabel.FIRST_NAME} Should be more than 1 Characters`
                },
                {
                  pattern: RegEx.names,
                  message:
                    'No special characters , Empty spaces or Numbers are Allowed'
                }
              ]}
              validateFirst={true}
              hasFeedback
            >
              <Input
                onInput={(e) => {
                  const target = e.target as HTMLInputElement;
                  target.value = FirstCap(target.value);
                }}
                placeholder={`Enter ${franchiseLabel.FIRST_NAME}`}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <Form.Item
              name={franchiseKey.LAST_NAME}
              label={franchiseLabel.LAST_NAME}
              labelCol={{span: 24}}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(franchiseLabel.LAST_NAME)
                },
                {
                  max: 100,
                  message: `${franchiseLabel.LAST_NAME} Should not be more than 100 Characters`
                },
                {
                  min: 2,
                  message: `${franchiseLabel.LAST_NAME} Should be more than 1 Characters`
                },
                {
                  pattern: RegEx.names,
                  message:
                    'No special characters , Empty spaces or Numbers are Allowed'
                }
              ]}
              validateFirst={true}
              hasFeedback
            >
              <Input
                onInput={(e) => {
                  const target = e.target as HTMLInputElement;
                  target.value = FirstCap(target.value);
                }}
                placeholder={`Enter ${franchiseLabel.LAST_NAME}`}
              />
            </Form.Item>
          </Col>
          {/* <Col className="gutter-row" span={8}> */}
          <Col className="gutter-row">
            <Form.Item
              name={franchiseKey.MOBILE}
              label={franchiseLabel.MOBILE}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(franchiseLabel.MOBILE)
                }
              ]}
              validateFirst={true}
              hasFeedback
              labelCol={{span: 24}}
            >
              <PhoneNumberInput name={franchiseKey.MOBILE} />
            </Form.Item>
          </Col>
          {/* <Col className="gutter-row" span={8}> */}
          <Col className="gutter-row">
            <Form.Item
              name={franchiseKey.EMAIL}
              rules={[
                {
                  required: true,
                  message: `${franchiseLabel.EMAIL} is required`
                },
                {
                  min: 5,
                  message: `${franchiseLabel.EMAIL} Should be more than 4 Characters`
                },
                {
                  max: 320,
                  message: `${franchiseLabel.EMAIL} Should not be more than 320 Characters`
                },
                {
                  pattern: RegEx.email,
                  message: CommonErrors.validField(franchiseLabel.EMAIL)
                }
              ]}
              label={franchiseLabel.EMAIL}
              labelCol={{span: 24}}
            >
              <Input
                className="input"
                placeholder={`Enter ${franchiseLabel.EMAIL}`}
              />
            </Form.Item>
          </Col>
          {/* <Col className="gutter-row" span={24}> */}
          <Col className="gutter-row">
            <Form.Item
              name={franchiseKey.ADDRESS}
              rules={[]}
              label={franchiseLabel.ADDRESS}
              labelCol={{span: 24}}
            >
              <Input
                className="input"
                placeholder={`Enter ${franchiseLabel.ADDRESS}`}
                onInput={(e) => {
                  const target = e.target as HTMLInputElement;
                  target.value = FirstCap(target.value);
                }}
              />
            </Form.Item>
          </Col>
          {/* <Col className="gutter-row" span={colSpan}> */}
          <Col className="gutter-row">
            <Form.Item shouldUpdate noStyle>
              {({getFieldValue}) => (
                <Form.Item
                  name={franchiseKey.COUNTRY}
                  label={franchiseLabel.COUNTRY}
                  rules={[
                    {
                      required: getFieldValue(franchiseKey.ADDRESS),
                      message: CommonErrors.mandatory(franchiseLabel.COUNTRY)
                    }
                  ]}
                  labelCol={{span: 24}}
                >
                  <Select
                    showSearch
                    className="select"
                    placeholder={`Choose ${franchiseLabel.COUNTRY}`}
                    filterOption={filterSelectOptions}
                    options={countryOptions}
                    onChange={(e) => {
                      setCountry(e);
                      if (country) {
                        setFields([
                          {
                            name: franchiseKey.STATE,
                            errors: ['Please Select State again'],
                            value: undefined
                          },
                          {
                            name: franchiseKey.CITY,
                            errors: ['Please Select City again'],
                            value: undefined
                          }
                        ]);
                      }
                    }}
                  />
                </Form.Item>
              )}
            </Form.Item>
          </Col>
          <Row gutter={rowGutter} style={{width: '100%'}}>
            {/* <Col className="gutter-row" span={colSpan}> */}
            <Col className="gutter-row" span={12}>
              <Form.Item shouldUpdate noStyle>
                {({getFieldValue}) => (
                  <Form.Item
                    name={franchiseKey.STATE}
                    label={franchiseLabel.STATE}
                    labelCol={{span: 24}}
                    rules={[
                      {
                        required: !!country,
                        message: CommonErrors.mandatory(franchiseLabel.STATE)
                      }
                    ]}
                  >
                    <Select
                      showSearch
                      className="select"
                      placeholder={`Choose ${franchiseLabel.STATE}`}
                      disabled={!getFieldValue(franchiseKey.COUNTRY)}
                      filterOption={filterSelectOptions}
                      value={data?.[franchiseKey.STATE] ?? undefined}
                      onChange={() => {
                        if (getFieldValue(franchiseKey.CITY)) {
                          setFields([
                            {
                              name: franchiseKey.CITY,
                              errors: ['Please Select City again'],
                              value: undefined
                            }
                          ]);
                        }
                      }}
                      options={
                        getFieldValue(franchiseKey.COUNTRY)
                          ? stateOptions.filter(
                              (item) =>
                                item?.country_id ===
                                getFieldValue(franchiseKey.COUNTRY)
                            )
                          : [{value: 0, label: ''}]
                      }
                    />
                  </Form.Item>
                )}
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={12}>
              <Form.Item shouldUpdate noStyle>
                {({getFieldValue}) => (
                  <Form.Item
                    name={franchiseKey.CITY}
                    label={franchiseLabel.CITY}
                    labelCol={{span: 24}}
                    rules={[
                      {
                        required: getFieldValue(franchiseKey.COUNTRY),
                        message: CommonErrors.mandatory(franchiseLabel.CITY)
                      }
                    ]}
                  >
                    <Select
                      showSearch
                      className="select"
                      placeholder={`Choose ${franchiseLabel.CITY}`}
                      disabled={
                        !(
                          getFieldValue(franchiseKey.STATE) &&
                          getFieldValue(franchiseKey.COUNTRY)
                        )
                      }
                      value={
                        cityOptions?.length > 0
                          ? data?.[franchiseLabel.CITY]
                          : undefined
                      }
                      filterOption={filterSelectOptions}
                      options={
                        getFieldValue(franchiseKey.STATE)
                          ? cityOptions?.filter(
                              (item) =>
                                item?.state_id ===
                                getFieldValue(franchiseKey.STATE)
                            )
                          : [{value: 0, label: ''}]
                      }
                    />
                  </Form.Item>
                )}
              </Form.Item>
            </Col>
          </Row>
          {/* <Col className="gutter-row" span={colSpan}> */}
          <Col className="gutter-row">
            <Form.Item shouldUpdate noStyle>
              {({getFieldValue}) => (
                <Form.Item
                  name={franchiseKey.PINCODE}
                  label={franchiseLabel.PINCODE}
                  rules={[
                    {
                      required: getFieldValue(franchiseKey.COUNTRY),
                      message: CommonErrors.mandatory(franchiseLabel.PINCODE)
                    },
                    {
                      pattern: RegEx.pinCode,
                      message: 'Special characters or spaces are not allowed.'
                    }
                  ]}
                  labelCol={{span: 24}}
                >
                  <Input
                    className="input"
                    placeholder={`Enter ${franchiseLabel.PINCODE}`}
                    onInput={(e) => {
                      const target = e.target as HTMLInputElement;
                      target.value = AllCap(target.value);
                    }}
                  />
                </Form.Item>
              )}
            </Form.Item>
          </Col>
        </>
      )}

      {currentStep === 1 && (
        <>
          {/* <Col className="gutter-row" span={colSpan}> */}
          <Col className="gutter-row">
            <Form.Item
              name={franchiseKey.NO_EMP}
              label={franchiseLabel.NO_EMP}
              labelCol={{span: 24}}
              rules={[
                {
                  pattern: RegEx.noZeroNoNegative,
                  message: 'Please enter non decimal value more than 0'
                }
              ]}
              initialValue={null}
            >
              <NumberInput
                className="input"
                placeholder={`Enter ${franchiseLabel.NO_EMP}`}
              />
            </Form.Item>
          </Col>
          {/* <Col className="gutter-row" span={colSpan}> */}
          <Col className="gutter-row">
            <Form.Item
              name={franchiseKey.FLOOR_SPACE}
              label={franchiseLabel.FLOOR_SPACE}
              rules={[
                {
                  pattern: RegEx.twoDigitDecimal,
                  message: CommonErrors.twoDigitPositive
                }
              ]}
              labelCol={{span: 24}}
              initialValue={null}
            >
              <NumberInput
                className="input"
                addonAfter={area}
                placeholder={`Enter ${franchiseLabel.FLOOR_SPACE}`}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <Form.Item dependencies={[franchiseKey.COUNTRY]} noStyle>
              {({getFieldValue}) => {
                return (
                  getFieldValue(franchiseKey.COUNTRY) === 101 && (
                    <Form.Item
                      name={franchiseKey.GST}
                      label={franchiseLabel.GST}
                      labelCol={{span: 24}}
                      rules={[
                        {
                          required: true,
                          message: CommonErrors.mandatory(franchiseLabel.GST)
                        },
                        {
                          pattern: RegEx.GST,
                          message: CommonErrors.validField(franchiseLabel.GST)
                        }
                      ]}
                    >
                      <Input
                        className="input"
                        onInput={(e) => {
                          const target = e.target as HTMLInputElement;
                          target.value = AllCap(target.value);
                        }}
                        placeholder={`Enter ${OPplaceholder.GST}`}
                      />
                    </Form.Item>
                  )
                );
              }}
            </Form.Item>
          </Col>
        </>
      )}
    </>
  );
};

export default FranchiseForm;
